export default "* Ting og materialer, som I vil vise frem fra jeres forløb om Ask & Liv\n* Instrumenter, musik og dans\n* Evt. bål\n* Evt. smagsprøver\n";